<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { Usesdata } from "../../../Data/Chart/Widget/ChartPage/Chart";
  import { chart } from "svelte-apexcharts";
  import { Uses } from "../../../utils/Constant/Constant";
</script>

<Col xl="7" class="xl-50 box-col-6">
  <div class="small-chart-widget chart-widgets-small">
    <Card cardHeaderprops="pb-0" headerTitle={Uses}>
      <div slot="contentbody">
        <div class="chart-container">
          <Row>
            <Col>
              <div id="chart-widget9">
                <div use:chart={Usesdata} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Card>
  </div>
</Col>
